import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Typography, Paper, Box, TextField, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SettingsIcon from '@mui/icons-material/Settings';
import Menu from '../components/Menu';
import NotificationContainer from '../components/NotificationContainer';
import api from '../utils/apiClient';
import { useNotifications } from '../context/NotificationContext';
import { AUTH_API } from '../utils/apiConfig';

const Settings = () => {
  const { t } = useTranslation('admin');
  const { showError, showSuccess } = useNotifications();
  const [password, setPassword] = useState('');
  const [touched, setTouched] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const isValid = password.length >= 6;

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setTouched(true);
    if (!isValid) {
      showError(t('settingsPasswordMinLengthError'));
      return;
    }

    setSubmitting(true);
    try {
      await api.post(
        `${AUTH_API}/v1/auth/password/change`,
        { password }
      );
      showSuccess(t('settingsPasswordChanged'));
      setPassword('');
      setTouched(false);
    } catch (error) {
      const message = error?.response?.data?.message || t('settingsPasswordChangeError');
      showError(message);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <>
      <Menu />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Paper sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <SettingsIcon sx={{ fontSize: 32, color: 'primary.main', mr: 2 }} />
            <Typography variant="h4" component="h1">
              {t('settingsTitle')}
            </Typography>
          </Box>
          
          <Box component="form" onSubmit={handleChangePassword} sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              {t('settingsChangePasswordTitle')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              <TextField
                type="password"
                label={t('settingsNewPasswordLabel')}
                size="small"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={() => setTouched(true)}
                error={touched && !isValid}
                helperText={touched && !isValid ? t('settingsPasswordMinLength') : undefined}
              />
              <Button
                type="submit"
                variant="contained"
                size="small"
                disabled={!isValid || submitting}
              >
                {submitting ? t('settingsPasswordSaving') : t('settingsChangePasswordButton')}
              </Button>
            </Box>
          </Box>

          
        </Paper>
      </Container>
      <NotificationContainer />
    </>
  );
};

export default Settings;
